import { Card } from '@nike/eds';
import { Close } from '@nike/nike-design-system-icons';
import { useSetAtom } from 'jotai';
import * as R from 'ramda';
import { rankingRuleTriggerModalAtom } from '../../atoms/ranking';
import { IconButton } from './IconButton';

const TriggerKeyword = ({
  keyword,
  onRemove,
}: {
  keyword: string;
  onRemove: () => void;
}) => {
  return (
    <span className='tw-relative tw-inline-flex tw-items-center tw-rounded-full tw-py-1 tw-px-2 tw-bg-gray-200 tw-group tw-border tw-border-solid tw-border-gray-300'>
      <span className='tw-px-2 tw-py-1 tw-text-sm tw-text-gray-950'>
        {keyword}
      </span>
      <IconButton
        className='tw-invisible group-hover:tw-visible tw-absolute tw-top-1 tw-right-1 tw-z-10'
        label='Remove'
        icon={<Close width={16} height={16} />}
        size='sm'
        onClick={onRemove}
        style={{ transform: 'translate(50%, -50%)' }}
      />
    </span>
  );
};

export default function TriggerKeywordSection(props: {
  items: string[];
  title: string;
  propKey: string;
}) {
  const items = props.items;
  const setTriggerModal = useSetAtom(rankingRuleTriggerModalAtom);
  return (
    <div className='tw-my-1'>
      <h4 className='tw-my-2'>{props.title}</h4>
      <Card className='tw-flex tw-flex-wrap tw-gap-1.5'>
        {items.map((keyword, idx) => {
          const onRemove = () => {
            setTriggerModal((modal) => {
              return {
                ...modal,
                visible: false,
                [props.propKey]: R.remove(idx, 1, items),
              };
            });
          };
          return (
            <TriggerKeyword
              keyword={keyword}
              key={`${props.propKey}_${idx}_${keyword}`}
              onRemove={onRemove}
            />
          );
        })}
      </Card>
    </div>
  );
}
